import React from 'react';
import DatePickers from '../CreateReference/DateAndTime';
import GooglePlacesAutocomplete from '../CreateReference/GooglePlacesAutocomplete';
import ProductForm from './editProducts';
import SearchForm from './editSource';
import FoeForm from '../CreateReference/FoeFormRef';
import TextAccordion from '../CreateReference/TextAccordionRef';
import EditRefButton from './editRefButton';
import ExternalRelease from './ExternalRelease';
import TitleForm from '../CreateReference/TitleFormRef';
import checkToken from '../../Token/checkToken'
import Menu from '../MenuBar';
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import { Alert, AlertTitle } from '@mui/material';
import ContestRelease from '../CreateReference/ContestRelease'
import ImageLoaderRef from '../CreateReference/ImageLoaderRef';
import { withTranslation } from 'react-i18next';

 class EditReference extends React.Component {

    constructor(props) {
        super(props)
        if(this.props.selectedReferenceData) {
            this.state = {open: false}
        } else {
            this.state = {open: true}
        }
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
    }

    handleCloseDialog() {
        this.setState({ open: false })
    }


    render() {

        const { t } = this.props;

        const userRole = localStorage.getItem('role_id');
        let externalReleaseComp;
        if (parseInt(userRole) === 1) {
            externalReleaseComp = <ExternalRelease />;
        }

        return (
            <div className='createRefClassFull'>
            { checkToken() ? 
               <div>
               <Menu />
               {this.props.selectedReferenceData ? 
                <div className='createRefClass'>
                   
                    <TitleForm />
                    <GooglePlacesAutocomplete/>
                    <ProductForm />
                    <FoeForm />
                    <DatePickers />
                    <TextAccordion />
                    <ImageLoaderRef />
                    {externalReleaseComp}
                    <ContestRelease />
                    <SearchForm />
                    <EditRefButton />                 
                    </div>
                : 
                <Dialog onClose={this.handleCloseDialog} aria-labelledby="simple-dialog-title" open={this.state.open}>

                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {t("edit_ref.edit_ref_select_error")}
                </Alert>

                  </Dialog>}
            </div>
            : window.location.reload()} </div>
        )
    }

}
const mapStateToProps = state => {

    return {
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}

export default connect(mapStateToProps)(withTranslation()(EditReference));